<template>
    <div class="form">
        <el-form :model="form" label-width="100px">
            <!-- <el-form-item label="vip号：">
                <el-input placeholder="请输入vip号" v-model="orderForm.single_number" @blur="getName(orderForm.single_number)"></el-input>
            </el-form-item> -->
            <el-form-item label="经销商：">
                <el-input disabled placeholder="请输入经销商" v-model="form.user_name"></el-input>
            </el-form-item>
            <el-form-item label="业务员：">
                <el-input disabled placeholder="请输入业务员" v-model="form.admin_user"></el-input>
            </el-form-item>
            <el-form-item label="备注：">
                <el-input :rows="3" type="textarea" placeholder="添加备注信息" v-model="form.postscript"></el-input>
            </el-form-item>
            <el-form-item label="上传附件：">
                <el-upload
                    class="avatar-uploader"
                    :http-request="handleChange"
                    action=""
                    accept="image/*"
                    drag
                    :show-file-list="false"
                    :before-upload="beforeUpload">
                    <img v-if="orderForm.order_images" :src="orderForm.order_images" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>

            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import { createNamespacedHelpers  } from 'vuex';
    const {mapMutations, mapState} = createNamespacedHelpers('supplyChainStore');
    import { session_id ,getUserInfo} from '../../stores/api';
    export default {
        data () {
            return {
                dialogVisible: false,
                form: {
                    agency: '程磊',
                    salesman: '程磊',
                    postscript: '',     //备注
                    single_number: '',  //订单号
                    order_images: '',
                    admin_user:'',
                    user_name:'',
                },
            };
        },
        methods: {
            beforeUpload (file) {
                const isLt500K = file.size / 1024 / 1024 < 0.5;
                if (!isLt500K) {
                    this.$message.error('请上传小于500Kb的图片!');
                }
                return isLt500K;
            },
            handleChange (info) {
                const reader = new FileReader();
                reader.addEventListener('load', () => (this.orderForm.order_images = reader.result));
                reader.readAsDataURL(info.file);
            },
            ...mapMutations(['setOrderForm']),
            //输入vip号获取经销商
            getName(num){
                console.log(num)
                this.$http.get(this.$reqUrl+'user.php?act=get_vipcard_staff&session_id='+session_id+'&single_number='+num)
                .then(res=>{
                    if(res.data==false){
                        this.$notify.error({
                            title: '操作失败',
                            message: "没有该vip卡号",
                        });
                        this.form.admin_user='';
                        this.form.user_name='';
                        return false;
                    }
                    this.form.admin_user=res.data.admin_user;
                    this.form.user_name=res.data.user_name;
                })

            }
        },
        computed: {
            ...mapState(['orderForm']),
        },
        mounted(){
            getUserInfo().then((res)=>{
                this.form.user_name=res.data.userinfo.user_name;
                this.form.admin_user=res.data.userinfo.admin_user_name;
            })
        },
        watch: {
            'form.postscript': function (val) {
                this.setOrderForm({postscript: val});
            },
            'form.single_number': function (val) {
                this.setOrderForm({single_number: val});
            },
            'form.order_images': function (val) {
                this.setOrderForm({order_images: val});
            },
        },
    };
</script>

<style lang="less" scoped>
    @import "../../default";

    .form {
        padding: 40px 20px;
        background: #ffffff;
        border: 1px solid #d8dde6;
        /deep/ .el-form-item {
            .el-form-item__content {
                width: 360px;
                color: @font_black;
                .el-textarea__inner, .el-input__inner {
                    color: @font_black;
                    border: 1px solid #d8dde6;
                    border-radius: 2px;
                }
            }
            .el-form-item__label {
                color: @font_black;

            }
        }

    }
</style>

<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .el-upload .avatar {
        width: 100%;
        height: 178px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/SupplyCh/Order.vue